import { gql } from '@apollo/client'

export const Track = gql`
    query Track($id: ID!, $roomId: ID) {
        track(id: $id, roomId: $roomId) {
            id
            album
            artist
            bitRate
            codec
            completed
            composer
            contributors {
                id
                username
            }
            coverArt {
                full
                thumb250
                thumb500
                thumb1200
            }
            created
            date
            duration
            files {
                bitRate
                duration
                key
                size
            }
            genre
            globalTags
            roomId
            size
            tags
            title
            track
            updated
            userId
            youtubeId
        }
    }
`

export default Track
